import { render, staticRenderFns } from "./QuestionType2.vue?vue&type=template&id=31075fcd&scoped=true"
import script from "./QuestionType2.vue?vue&type=script&lang=js"
export * from "./QuestionType2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31075fcd",
  null
  
)

export default component.exports